export default "__VITE_ASSET__96e84f2c__"